module.exports = __webpack_public_path__ + "static/banner_side-1592c2e46d49afa6311aacac952209b1.png";